import History from "./History";
import useHistoryPageStore from "./store";

export default History;

export { useHistoryPageStore };
